<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 style="font-weight: 400">นโยบายรหัสผ่าน</h2>
    </div>
    <v-card outlined class="pa-4">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div>
          <h3 class="body-1">ความยาวรหัสผ่านขั้นต่ำ</h3>
          <div class="mt-1 d-flex align-center">
            <div style="width: 80px">
              <v-text-field
                v-model.number="passwordPolicy.password_minimum_length.value"
                :rules="[
                  (v) => !!v || 'โปรดระบุความยาวรหัสผ่านขั้นต่ำ',
                  (v) =>
                    (v && v >= 6 && v <= 128) ||
                    'ต้องมีความยาวระหว่าง 6 ถึง 128 ตัวอักษร',
                ]"
                type="number"
                min="6"
                max="128"
                outlined
                dense
                hide-details
              ></v-text-field>
            </div>
            <span class="ml-2 body-2 grey--text text--darken-3">ตัวอักษร</span>
          </div>
          <p
            :class="`mt-2 body-2 ${
              !valid ? 'red--text' : 'grey--text text--darken-2'
            }`"
          >
            ต้องมีความยาวระหว่าง 6 ถึง 128 ตัวอักษร
          </p>
        </div>
      </v-form>
      <div class="mt-3">
        <h3 class="body-1">ความปลอดภัยของรหัสผ่าน</h3>
        <div class="mt-1">
          <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.require_latin_upper_case.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              ต้องมีอักษรอังกฤษตัวพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัวอักษร
            </span>
          </div>
          <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.require_latin_lower_case.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              ต้องมีอักษรอังกฤษตัวพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัวอักษร
            </span>
          </div>
          <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.require_number.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              ต้องมีตัวเลข (0-9) อย่างน้อย 1 ตัว
            </span>
          </div>
          <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.require_non_alphanumeric.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              ต้องมีอักขระพิเศษอย่างน้อย 1 ตัวอักษร
            </span>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <h3 class="body-1">ข้อกำหนดอื่น ๆ</h3>
        <div class="mt-1">
          <!-- <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.password_expiration.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              รหัสผ่านหมดอายุทุก 90 วัน
            </span>
          </div> -->
          <!-- <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.admin_reset_expiration_password.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              เมื่อรหัสผ่านหมดอายุ ระบบจะบังคับให้เปลี่ยนรหัสผ่านใหม่
            </span>
          </div> -->
          <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.allow_user_reset_password.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              อนุญาตให้ผู้ใช้เปลี่ยนรหัสผ่านของตนเองได้
            </span>
          </div>
          <!-- <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="passwordPolicy.prevent_password_reuse.is_enable"
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              ป้องกันการใช้รหัสผ่านซ่ำกัน 24 ครั้งที่ผ่านมา
            </span>
          </div> -->
          <div class="d-flex align-center">
            <input
              type="checkbox"
              v-model="
                passwordPolicy.prevent_password_same_as_employee_code.is_enable
              "
            />
            <span class="ml-2 body-2 py-1 grey--text text--darken-2">
              รหัสผ่านห้ามซ้ำกับรหัสพนักงาน
            </span>
          </div>
        </div>
      </div>
    </v-card>
    <div class="mt-4">
      <v-btn
        color="primary"
        :disabled="
          !isPasswordPolicyChanged ||
          (uiCtrl &&
            !uiCtrl.isEnable('btn:::company_config:password_policy:update'))
        "
        @click="onSave"
      >
        บันทึก</v-btn
      >
      <v-btn class="ml-2" @click="onCancel">ยกเลิก</v-btn>
    </div>

    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'PasswordPolicy',
  components: {
    ConfirmDialog,
  },
  data: () => ({
    valid: true,
    dialogForbidden: false,
    confirmDialogDataChange: false,
    confirmDialogDataChangeLoading: false,
    confirmDialogDataChangeData: {},
    passwordPolicy: {
      require_latin_upper_case: {},
      require_latin_lower_case: {},
      require_number: {},
      require_non_alphanumeric: {},
      password_minimum_length: {},
      password_expiration: {},
      admin_reset_expiration_password: {},
      allow_user_reset_password: {},
      prevent_password_reuse: {},
      prevent_password_same_as_employee_code: {},
    },
    passwordPolicyInit: {
      require_latin_upper_case: {},
      require_latin_lower_case: {},
      require_number: {},
      require_non_alphanumeric: {},
      password_minimum_length: {},
      password_expiration: {},
      admin_reset_expiration_password: {},
      allow_user_reset_password: {},
      prevent_password_reuse: {},
      prevent_password_same_as_employee_code: {},
    },
  }),
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isPasswordPolicyChanged() {
      return (
        JSON.stringify(this.passwordPolicyInit) !==
        JSON.stringify(this.passwordPolicy)
      )
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'นโยบายรหัสผ่าน',
        disabled: true,
      },
    ])

    try {
      this.$store.state.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
      }

      await this.fetchPasswordPolicy(payload)

      const passwordPolicy = this.$store.state.password.passwordPolicy

      this.passwordPolicy = JSON.parse(JSON.stringify(passwordPolicy))
      this.passwordPolicyInit = JSON.parse(JSON.stringify(passwordPolicy))
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchPasswordPolicy: 'password/fetchPasswordPolicy',
      editPasswordPolicy: 'password/editPasswordPolicy',
    }),
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      this.confirmDialogDataChange = false
      this.nextRoute(item.data)
    },
    nextRoute(next) {
      next()
    },
    onCancel() {
      this.passwordPolicy = JSON.parse(JSON.stringify(this.passwordPolicyInit))
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: this.passwordPolicy,
          }

          await this.editPasswordPolicy(payload)

          this.passwordPolicyInit = JSON.parse(
            JSON.stringify(this.passwordPolicy)
          )

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isPasswordPolicyChanged) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการปิดใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      next()
    }
  },
}
</script>
